/**
 * Copyright IBM Corp. 2022, 2026
 */

import { useFormContext, useFormState, useWatch } from 'react-hook-form'
import { MarketoForm } from './form'
import Field from './partials/field'

export { useFormContext, useFormState, useWatch, Field }
export default MarketoForm
